import { axiosJsonInstance } from 'src/store/api';

export default {
  async fetchPolygons(cameraId: number | undefined) {
    return await axiosJsonInstance.get('polygons/', {
      params: {
        camera_id: cameraId,
      },
    });
  },
  async fetchPolygon(polygonId: number) {
    return await axiosJsonInstance.get(`polygons/${polygonId}/`);
  },
  async fetchAllPolygonMetrics(startDate: string, endDate: string) {
    return await axiosJsonInstance.get('all-polygon-metrics/', {
      params: {
        start_date: startDate,
        end_date: endDate,
      },
    });
  },
};
